import { Check } from '@finn/design-system/icons/check';
import { USPBannerData } from '@finn/ui-cosmic';

const USPBanner = ({ data }: { data: USPBannerData }) => {
  if (!data.title) return;

  return (
    <div className="bg-snow flex flex-col gap-4 px-4 py-6 md:flex-row md:justify-between md:gap-20">
      <h2 className="global-t6-semibold md:global-t5-semibold flex">
        {data.title}
      </h2>

      {data.variant === 'paid_marketing_campaign' && (
        <div className="flex flex-col gap-2 md:flex-row md:gap-8">
          <div className="flex items-center gap-2 md:flex-col md:text-center">
            <Check height={24} />
            <span className="body-14-regular">
              {data.paid_marketing_campaign.usp_1}
            </span>
          </div>
          <div className="flex items-center gap-2 md:flex-col md:text-center">
            <Check height={24} />
            <span className="body-14-regular">
              {data.paid_marketing_campaign.usp_2}
            </span>
          </div>
          <div className="flex items-center gap-2 md:flex-col md:text-center">
            <Check height={24} />
            <span className="body-14-regular">
              {data.paid_marketing_campaign.usp_3}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default USPBanner;
